var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7272 2.25775L14.4872 5.80675C14.7272 6.30075 15.3672 6.77475 15.9072 6.86475L19.0962 7.39975C21.1362 7.74275 21.6162 9.23475 20.1462 10.7067L17.6662 13.2067C17.2462 13.6297 17.0162 14.4467 17.1462 15.0317L17.8562 18.1267C18.4162 20.5767 17.1262 21.5237 14.9762 20.2437L11.9862 18.4587C11.4462 18.1367 10.5562 18.1367 10.0062 18.4587L7.01822 20.2437C4.87822 21.5237 3.57822 20.5657 4.13822 18.1267L4.84822 15.0317C4.97822 14.4467 4.74822 13.6297 4.32822 13.2067L1.84822 10.7067C0.389217 9.23375 0.859217 7.74275 2.89822 7.39975L6.08822 6.86475C6.61822 6.77475 7.25822 6.30075 7.49822 5.80675L9.25822 2.25775C10.2182 0.332745 11.7782 0.332745 12.7282 2.25775",
    stroke: "#8C8D96",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import-icon.5743e38023b916018ab720fd2a5d8741.svg";
export { ForwardRef as ReactComponent };